import React, { useMemo } from "react";
import BaseChart from "../../components/ui/BaseChart";
import CountUp from "react-countup";

const CounterRequestedChart = ({ data }) => {
  const { counter = 0, requested = 0, total = 0 } = data ?? {};
  const counterPct  = total > 0 ? Math.round((counter  / total) * 100) : 0;
  const requestedPct = total > 0 ? Math.round((requested / total) * 100) : 0;

  const chartOptions = useMemo(
    () => ({
      chart: {
        type: "pie",
        height: 260,
        margin: [0, 0, 0, 0],
      },
      title: { text: null },
      tooltip: {
        formatter() {
          return `<b>${this.point.name}</b>: ${this.point.y} (${this.point.percentage?.toFixed(1)}%)`;
        },
        backgroundColor: "#1e293b",
        style: { color: "#f8fafc" },
        borderWidth: 0,
        borderRadius: 6,
      },
      plotOptions: {
        pie: {
          innerSize: "60%",
          dataLabels: { enabled: false },
          showInLegend: false,
          startAngle: -90,
          endAngle: 90,
          center: ["50%", "90%"],
          size: "170%",
        },
      },
      series: [
        {
          name: "Offers",
          data: [
            { name: "Counter", y: counter, color: "#7C3AED" },
            { name: "Requested", y: requested, color: "#0F40AE" },
          ],
          borderWidth: 2,
        },
      ],
    }),
    [counter, requested],
  );

  return (
    <div>
      <BaseChart options={chartOptions} className="w-full" />
      {/* Total */}
      <div className="text-center mt-2 mb-1">
        <p className="text-[10px] text-gray-400">Total Work Orders</p>
        <p className="text-lg font-bold text-gray-700">
          <CountUp start={0} end={total} duration={1.2} />
        </p>
      </div>
      {/* Stats row */}
      <div className="flex justify-center gap-6">
        <div className="flex items-center gap-2">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#7C3AED]" />
          <div className="text-left">
            <p className="text-[11px] font-semibold text-gray-700">
              <CountUp start={0} end={counter} duration={1.2} />
              <span className="text-gray-400 font-normal ml-1">
                (<CountUp start={0} end={counterPct} duration={1.2} />%)
              </span>
            </p>
            <p className="text-[10px] text-gray-400 leading-none">Counter</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#0F40AE]" />
          <div className="text-left">
            <p className="text-[11px] font-semibold text-gray-700">
              <CountUp start={0} end={requested} duration={1.2} />
              <span className="text-gray-400 font-normal ml-1">
                (<CountUp start={0} end={requestedPct} duration={1.2} />%)
              </span>
            </p>
            <p className="text-[10px] text-gray-400 leading-none">Requested</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterRequestedChart;
